

























































import { Vue, Component, Watch } from "vue-property-decorator";
import * as auth from "../../_store/auth.module";
import * as user from "../../_store/user.module";
import DynamicMenu from "./DynamicMenu.vue";
import Vuetify from 'vuetify';

@Component({
  components: {
    DynamicMenu
  }
})
export default class SideBarMenu extends Vue {
  private userData: object;
  drawer: boolean;
  wideMonitor: boolean;
  constructor() {
    super();
    this.userData = {};
    this.drawer = false;
    this.wideMonitor = false;
  }

  get isUserAuthenticated() {
    var token: string | null = auth.readToken(this["$store"]);
    // var token: string | null = localStorage.getItem("userToken");
    return token !== null && token !== undefined;
  }

  get screenWidth(){
    let breakPoint = this.$vuetify.breakpoint.name; 
    this.wideMonitor = false;
    if (breakPoint === 'xl'){
      this.wideMonitor = true;
    }

    if (this.wideMonitor === true){
      this.drawer = true;
    }
    return this.drawer;
  }

  set screenWidth(value){
    this.drawer = value;
  }

  exit(): void {
    if (confirm("Effettuare il Logout dall'applicazione?")) {
      auth.dispatchLogout(this["$store"]);
      user.dispatchClearState(this["$store"]);
      this["$router"].push("/login");
    }
  }
}
